module.exports = "/_next/static/files/5e3f7f940a6048a486edaed1a01fc935.png";